<template>
  <div class="subject-list">
    <div class="subject-list-line"
      v-for="(chunk, i) in chunkedSubjects"
      :key="i">

      <div v-for="([subject, color], i) in chunk"
      :class="`subject-list-skill subject-list-${color}`"
      :key="i">
        {{ subject }}</div>
    </div>
  </div>
</template>

<script>
import subjectData from '@/data/subjects.json'
import { chunk, matchMedia, debounce } from '@/utils/helpers'
export default {
  data: function () {
    return {
      subjects: subjectData,
      chunkSize: matchMedia(21, 12)
    }
  },
  computed: {
    chunkedSubjects () {
      return chunk(this.subjects, this.chunkSize)
    }
  },
  methods: {
    handleResize () {
      this.chunkSize = matchMedia(21, 12)
    }
  },
  mounted () {
    window.addEventListener('resize', debounce(this.handleResize, 200))
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style lang="scss">
  @import '~@/styles/media';
  $lines: 7;

  .subject-list {
    position: relative;
    padding: 20px 0;
    overflow: hidden;

    @for $i from 0 to $lines {
      .subject-list-line:nth-child(#{$i + 1}) {
        margin-left: -$i * 20px;
        // animation-duration: $i + 9s;
        animation-duration: 45s;
      }
    }

    @keyframes slowmove {
      0% {
        transform: translateX(0);
      }
      100% {
        transform: translateX(-70%);
      }
    }

    &-line {
      width: 100%;
      white-space: nowrap;
      animation-name: slowmove;
      animation-iteration-count: infinite;
      animation-timing-function: linear;
      animation-direction: alternate;
      will-change: transform;
    }

    &-skill {
      padding: 0 26px;
      height: 35px;
      font-size: 14px;
      line-height: 35px;
      border-radius: 11px;
      border-style: solid;
      border-width: 2px;
      display: inline-block;
      vertical-align: middle;
      margin: 5px;
      white-space: nowrap;
      text-align: center;
      font-family: 'ProximaNova-Bold';
      color: var(--primary-white);
    }

    &-green {
      border-color: #00CCA0;
      background-color: #00c8a1;
    }

    &-purple {
      border-color: #AB70FB;
      background-color: #a177f3;
    }

    &-blue {
      border-color: #007EFF;
      background-color: #027fff;
    }

    &-yellow {
      border-color: #FFC600;
      background-color: #fcc719;
      color: var(--primary-black);
    }

    @media #{$desktop} {
      @for $i from 0 to $lines {
        .subject-list-line:nth-child(#{$i + 1}) {
          margin-left: -$i * 120px;
          // animation-duration: $i + 9s;
          // animation-duration: 45s;
        }
      }
      // .subject-list-line {
      //   &:nth-child(1) {
      //     margin-left: -120px;
      //     animation-duration: 17s;
      //   }
      //   &:nth-child(2) {
      //     margin-left: 18s;
      //   }
      //   &:nth-child(3) {
      //     margin-left: 19s;
      //   }
      //   &:nth-child(4) {
      //     margin-left: 20s;
      //   }
      // }

      &-skill {
        padding: 0 20px;
        font-size: 18px;
        width: 216px;
        height: 76px;
        line-height: 76px;
        border-radius: 11px;
        border-style: solid;
        border-width: 2px;
        margin: 10px 5px;
        display: inline-block;
        vertical-align: middle;
        margin: 10px;
        white-space: normal;
      }
    }
  }
</style>
